import React, { Suspense } from 'react'
import {
  GlobalBadgesStyled,
  GlobalBadgesBackgroundStyled,
  GlobalBadgesContentStyled,
  GlobalBadgesListStyled,
  GlobalBadgesListItemStyled
} from './styles'
import MediaItem from './../../molecules/MediaItem'
import { GlobalBadgesProps } from './types'

const TooltipBadge = React.lazy(() => import('./../../molecules/TooltipBadge'))

const GlobalBadges: React.FC<GlobalBadgesProps> = ({ iconList, backgroundImage }) => {
  return (
    <GlobalBadgesStyled>
      {backgroundImage && (
        <GlobalBadgesBackgroundStyled>
          <MediaItem media={backgroundImage} />
        </GlobalBadgesBackgroundStyled>
      )}
      {iconList && (
        <GlobalBadgesContentStyled>
          <GlobalBadgesListStyled>
            {iconList.map((icon) => (
              <GlobalBadgesListItemStyled key={icon.key}>
                {typeof window !== 'undefined' && (
                  <Suspense fallback={<div />}>
                    <TooltipBadge data={icon} />
                  </Suspense>
                )}
              </GlobalBadgesListItemStyled>
            ))}
          </GlobalBadgesListStyled>
        </GlobalBadgesContentStyled>
      )}
    </GlobalBadgesStyled>
  )
}

export default GlobalBadges
